/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { SystemVarsRestService } from '@gh/builder-shared-data';

import { InitViewService } from '@gh/common-shared';

import { Observable } from 'rxjs';

import { SystemVarsSupervisor } from './model/system-vars-supervisor.model';

@Injectable()
export class SystemVarsSupervisorTabBusinessService implements InitViewService {
  constructor(private restService: SystemVarsRestService) {
  }

  initView(): any {
    return {
      supervisorSystemVariables: this.restService.getSupervisor(),
    };
  }

  get(): Observable<SystemVarsSupervisor> {
    return this.restService.getSupervisor();
  }

  update(supervisor: SystemVarsSupervisor): Observable<SystemVarsSupervisor> {
    return this.restService.updateSupervisor(supervisor);
  }
}
